import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { pluralize } from 'utils/plural'

const Wrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 0px;

  ${up('sm')} {
    padding-top: 24px;
    padding-botton: 0px;
  }
`

const Title = styled.h4`
  font-size: 17px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 40px;
`

const BulletList = styled.div`
  padding-bottom: 40px;
  display: flex;
`

const BulletItem = styled.div`
  padding-right: 26px;

  ${up('md')} {
    padding-right: 0;
    flex: 1 1 auto;
  }
`

const BulletIcon = styled.img`
  display: block;
  margin: 0 auto 10px auto;

  ${up('md')} {
    display: inline-block;
    margin: 0 10px 0 0;
  }
`

interface Props {
  property: any
}

export const Places: ComponentType<Props> = ({ property }) => {
  const hasFloors = !!property.places.floors
  const hasRooms = !!property.places.rooms
  const hasBathrooms = !!property.places.bathrooms
  const hasHalfBathrooms = !!property.places?.halfBathrooms
  const hasParkingCeilings = !!property.places?.parkingSpacesCeiling
  const hasParkingNoCeilings = !!property.places?.parkingSpacesNoCeiling

  if (hasFloors || hasRooms || hasBathrooms || hasHalfBathrooms || hasParkingCeilings || hasParkingNoCeilings) {
    return (
      <Wrapper>
        <Title>Áreas</Title>
        <BulletList>
          {hasFloors && (
            <BulletItem>
              <BulletIcon src="/images/floors-icon.svg" />{' '}
              <span className="font-size-14 text-uppercase font-weight-600">
                {pluralize(property.places.floors, 'Niveles', 'Nivel')}
              </span>
            </BulletItem>
          )}
          {hasRooms && (
            <BulletItem>
              <BulletIcon src="/images/rooms-icon.svg" />{' '}
              <span className="font-size-14 text-uppercase font-weight-600">
                {pluralize(property.places.rooms, 'Recámaras', 'Recámara')}
              </span>
            </BulletItem>
          )}
          {hasBathrooms && (
            <BulletItem>
              <BulletIcon src="/images/bathrooms-icon.svg" />{' '}
              <span className="font-size-14 text-uppercase font-weight-600">
                {pluralize(property.places.bathrooms, 'Baños', 'Baño')}
              </span>
            </BulletItem>
          )}
        </BulletList>
        {hasHalfBathrooms && (
          <div className="py-15 pr-30 d-flex justify-content-between border-top">
            <div>Medios baños</div>
            <div className="text-primary">{property.places.halfBathrooms}</div>
          </div>
        )}
        {hasParkingCeilings && (
          <div className="py-15 pr-30 d-flex justify-content-between border-top">
            <div>Estacionamientos techados</div>
            <div className="text-primary">{property.places.parkingSpacesCeiling}</div>
          </div>
        )}
        {hasParkingNoCeilings && (
          <div className="py-15 pr-30 d-flex justify-content-between border-top">
            <div>Estacionamientos exteriores</div>
            <div className="text-primary">{property.places.parkingSpacesNoCeiling}</div>
          </div>
        )}
      </Wrapper>
    )
  }

  return null
}
